import Titles from "./Titles";

export default Titles;
